import React from "react";
import { MdClose } from "react-icons/md";
import { IconButton } from "@mui/material";

const Header = ({ title, onClose }) => {
    return (
        <div style={{
            padding: "16px 30px",
            backgroundColor: "var(--color-surface-panel)",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            borderBottom: "1px solid var(--color-border-default)",
            minHeight: "70px"
        }}>
            {/* Title */}
            <h2 style={{
                fontWeight: "600",
                fontSize: "22px",
                color: "var(--text-secondary-color)",
                fontFamily: "Montserrat, sans-serif",
                margin: 0,
                letterSpacing: "-0.3px"
            }}>
                {title}
            </h2>

            {/* Close button */}
            <IconButton
                onClick={onClose}
                style={{
                    color: "var(--text-secondary-color)",
                    padding: "8px"
                }}
            >
                <MdClose size={24} />
            </IconButton>
        </div>
    );
};

export default Header;

